export const HOME = { emergentLink: "home-emergent-link" };

export const TIDS = {
  // Age gate
  ageGateDob: "age-gate-dob",
  ageGateAttest: "age-gate-attest",
  ageGateConfirm: "age-gate-confirm",
  ageGateExit: "age-gate-exit",

  // Auth
  navLogin: "nav-login",
  navSignup: "nav-signup",
  navLogout: "nav-logout",
  navDashboard: "nav-dashboard",
  navBrowse: "nav-browse",
  navTournaments: "nav-tournaments",
  navSubscribe: "nav-subscribe",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  signupUsername: "signup-username-input",
  signupEmail: "signup-email-input",
  signupPassword: "signup-password-input",
  signupDob: "signup-dob-input",
  signupAttest: "signup-attest-checkbox",
  signupSubmit: "signup-submit-button",

  // Landing
  landingCtaSignup: "landing-cta-signup",
  landingCtaBrowse: "landing-cta-browse",

  // Browse
  browseGrid: "browse-grid",
  streamCard: "stream-card",

  // Channel
  channelGoLive: "channel-go-live-button",
  channelOffline: "channel-offline-button",
  channelTitleInput: "channel-title-input",
  channelSubscribe: "channel-subscribe-button",
  channelGuestRequest: "channel-guest-request-button",
  channelGameSelect: "channel-game-select",
  chatInput: "chat-input",
  chatSend: "chat-send-button",
  chatList: "chat-list",
  streamVideo: "stream-video-element",

  // Games
  gameTtt: "game-ttt",
  gameConnect4: "game-connect4",
  gameCell: "game-cell",
  gameReset: "game-reset-button",

  // Tournaments
  tournamentJoin: "tournament-join-button",
  tournamentRow: "tournament-row",

  // Subscribe
  subFree: "sub-tier-free",
  subPlus: "sub-tier-plus-button",
  subPremium: "sub-tier-premium-button",
};
